export const initMenuToggle = () => {
  const nav = document.querySelector('[data-nav-container]');
  const toggle = document.querySelector('[data-nav-toggle]');
  const scrim = document.querySelector('[data-mobile-scrim]');

  // Nothing to do if markup is missing (e.g., widgetized pages).
  if (!nav || !toggle) {
    return;
  }

  // Toggle helper so multiple events reuse the same class/ARIA logic.
  const setState = (open) => {
    nav.classList.toggle('is-active', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);
  };

  toggle.addEventListener('click', () => {
    const isOpen = nav.classList.contains('is-active');
    setState(!isOpen);
  });

  if (scrim) {
    scrim.addEventListener('click', () => setState(false));
  }

  // Collapse on focus loss or escape key for accessibility.
  nav.addEventListener('blur', () => setState(false), true);
  window.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') {
      setState(false);
    }
  });
};
